import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { Picture } from 'components/picture';
import { SanityBlockRenderer } from 'components/sanity-block-renderer';
import { LoyaltyRewardsLogo } from 'pages/loyalty/loyalty-rewards-logo';

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 100%;
`;

export const HeadingText = styled.h1`
  text-transform: ${Styles.textTransform.headlines};
  font-family: ${Styles.fontFamily.base};
  font-size: 3.25rem;
  text-align: center;
  color: ${Styles.color.secondary};
  margin: 0;
  ${Styles.mobileTiny} {
    font-size: 1.75rem;
  }
`;

export const LogoContainer = Picture;

export const ImageContainer = styled(Picture)`
  max-height: 28vh;
  && {
    margin-block-start: 1rem;
    margin-block-end: 0;
    margin-inline: 0;
  }
  ${Styles.mobileTiny} {
    margin-block-start: 1rem;
    margin-block-end: 0;
    margin-inline: 0;
    max-height: 20vh;
  }
`;

export const TitleText = styled.h2<{ $fontColor?: string }>`
  font-family: ${Styles.fontFamily.base};
  text-transform: ${Styles.textTransform.headlines};
  margin: 0;
  ${Styles.mobileTiny} {
    font-size: 1rem;
  }
`;

export const SubtitleText = styled.h4`
  width: 95%;
  font-family: ${Styles.fontFamily.body};
  margin-block-start: 0;
  margin-block-end: 2rem;
  margin-inline: 0;
  font-size: 1rem;
  ${Styles.mobileTiny} {
    font-size: 1rem;
  }
`;

export const DescriptionTextBlock = styled(SanityBlockRenderer)`
  font-size: 1rem;
  font-family: ${Styles.fontFamily.body};
  max-width: 95%;
  margin-block-start: 0;
  margin-block-end: 1rem;
  margin-inline: auto;
  ${Styles.mobileTiny} {
    font-size: 0.95rem;
  }
`;

export const StyledButton = styled(ActionButton)`
  padding: 0.75rem 2rem;

  ${Styles.mobileTiny} {
    padding: 0.75rem 1rem;
  }
`;

export const ButtonWrapper = styled.div`
  margin-block-start: 1.15rem;
  margin-block-end: 0;
  margin-inline: auto;
  width: 100%;
`;

export const DesktopBar = styled.div`
  position: fixed;
  inset-block-end: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.25rem 1rem;
  width: 100%;
  height: 4.7rem;
  background-color: ${Styles.color.white};
`;

export const FullPageImage = styled(Picture)`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const StyledLoyaltyLogo = styled(LoyaltyRewardsLogo)`
  height: 3.5rem;
  margin-block-end: 0.5rem;
  ${Styles.desktop} {
    margin-block-start: 1rem;
  }
`;

export const Terms = styled(SanityBlockRenderer)`
  width: 90%;
  font-size: 0.75rem;
  margin: 1rem auto;
`;
